import store from "@/store/store";
import {
  getApplicationLocalStorageItem,
  setApplicationLocalStorageItem
} from "@/helpers.js";

export default async function authGuard(to, from, next) {
  // Adiciona um delay aleatório entre 5 e 20ms antes de continuar a navegação
  // const delayMs = 5000 + Math.random() * 15000; // 5000..20000
  // await new Promise(resolve => setTimeout(resolve, delayMs));

  if (from.name === "menu-builder") {
    setApplicationLocalStorageItem(
      "menu",
      getApplicationLocalStorageItem("currentUserMenu")
    );
  }

  await store.dispatch("auth/reloadState");

  if (to.path === '/login-checker') {

    const use_sso = getApplicationLocalStorageItem('use_microsoft_sso')

    if (use_sso) {
      setTimeout(() => {
        if (getApplicationLocalStorageItem('accessDenied') === true) {
          setApplicationLocalStorageItem('accessDenied', false)
          return next('/error-403')
        } else if (getApplicationLocalStorageItem("accessToken") !== '') {
          return next('/home')
        } else {
          return next();
        }
      }, 700)
    } else {
      if (getApplicationLocalStorageItem("accessToken") !== '') {
        return next('/home')
      } else {
        return next();
      }
    }

  } else if (to.path === "/login") {
    if (JSON.stringify(store.state.auth.login_parameters) === '{}') {
      return next('/login-checker')
    }

    if (getApplicationLocalStorageItem("accessToken") !== '') {
      await store.dispatch("auth/checkSession", {
        app_token: getApplicationLocalStorageItem("app_token"),
        session_token: getApplicationLocalStorageItem("accessToken"),
        api_url: getApplicationLocalStorageItem("api_url")
      })
        .then(response => {
          const redirectUrl = JSON.parse(getApplicationLocalStorageItem("role"))["home_url"];

          return next(redirectUrl);
        })
        .catch(() => {
          // store.dispatch("auth/clearStorage");
          return next('/login-checker');

        })
    }

    return next();
  } else if (to.name === "page-reset-password-by-token" || to.path === "/error-500" || to.path === '/error-403') {
    return next();
  } else {
    try {
      if (getApplicationLocalStorageItem("accessToken") === '') {
        return next('/login-checker')
      }

      await store.dispatch("auth/checkSession", {
        app_token: getApplicationLocalStorageItem("app_token"),
        session_token: getApplicationLocalStorageItem("accessToken"),
        api_url: getApplicationLocalStorageItem("api_url")
      })
        .then(response => {
          if (response.status === 200) {
            const user = JSON.parse(getApplicationLocalStorageItem("user"));
            if (user.change_password && to.name !== "page-reset-password") {
              return next({ name: "page-reset-password" });  // Redirect to reset password
            } else {
              return next();  // Proceed to the requested route
            }
          } else {
            store.dispatch("auth/clearStorage");
            store.dispatch("auth/signOut");
            return next('/login');  // Redirect to login
          }
        })
        .catch(err => {
          console.log(err);
          return next('/login');
        })
    } catch (err) {
      console.log(err);
      return next('/login');  // Redirect to login on error
    }
  }
}

